import React from 'react';

const Education = () => {
    return (
        <React.Fragment>
            <div className="block-title">
                <h3>Education</h3>
            </div>
            <div className="timeline">
                {/* Single event */}
                <div className="timeline-event te-primary">
                    <h5 className="event-date">2021</h5>
                    <h4 className="event-name">Master of Computer Science</h4>
                    <span className="event-description">
                        University of Iowa, Iowa City, IA, USA
                    </span>
                </div>
                {/* Single event */}
                <div className="timeline-event te-primary">
                    <h5 className="event-date">2017</h5>
                    <h4 className="event-name">B.S. Computer Science</h4>
                    <span className="event-description">
                        National University of Computer and Emerging Sciences, Lahore, PK
                    </span>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Education;